import React from 'react';
import { Form, Modal, Radio, Segmented, theme, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { TGDExerciseType, TGraphicDesignLessonConfig } from '../../../models/courses/graphicDesign';
import { isIntentRead } from './steps';

interface Props { config: TGraphicDesignLessonConfig;
  onChange: (patch: Partial<TGraphicDesignLessonConfig>) => void; readOnly?: boolean }
const types: TGDExerciseType[] = ['CREATE', 'TRANSFORM', 'CRITIQUE', 'CHOOSE', 'INTENT'];
const ExerciseTypePicker: React.FC<Props> = ({ config, onChange, readOnly }) => {
  const { t } = useTranslation();
  const { token } = theme.useToken();
  const changeType = (exerciseType: TGDExerciseType) => {
    if (exerciseType === config.exerciseType) return;
    if (config.rules.length || config.zones?.length || config.versions?.length) {
      Modal.confirm({ title: t('graphicDesignLesson.admin.typeConfirmTitle'),
        content: t('graphicDesignLesson.admin.typeConfirmBody'),
        onOk: () => onChange({ exerciseType }) });
    } else onChange({ exerciseType });
  };
  const changeMode = (mode: string | number) => {
    if (mode === 'read' && !isIntentRead(config)) onChange({ versions: [{ id: 'v1',
      label: { fr: 'Version 1' }, design: { background: config.background, components: [] } }] });
    if (mode === 'write' && isIntentRead(config)) Modal.confirm({
      content: t('graphicDesignLesson.admin.intentRemove'), onOk: () => onChange({
        versions: [], choices: [], rules: config.rules.filter(rule =>
          rule.type !== 'choiceEquals' && rule.type !== 'reasonEquals'),
      }),
    });
  };
  return <Form layout="vertical"><Form.Item label={t('graphicDesignLesson.admin.exerciseType')}>
    <Radio.Group value={config.exerciseType} onChange={event => changeType(event.target.value)}
      disabled={readOnly} style={{ display: 'flex', flexDirection: 'column', gap: 8, width: '100%' }}>
      {types.map(type => <div key={type} className="gd-type-option" style={{
        borderColor: config.exerciseType === type ? token.colorPrimary : token.colorBorder,
      }}><Radio value={type}><strong>{t(`graphicDesignLesson.admin.types.${type}.title`)}</strong>
        <div><Typography.Text type="secondary">{t(`graphicDesignLesson.admin.types.${type}.desc`)}</Typography.Text></div>
      </Radio></div>)}
    </Radio.Group>
  </Form.Item>{config.exerciseType === 'INTENT' && <Form.Item
    label={t('graphicDesignLesson.admin.intentMode')}>
    <Segmented value={isIntentRead(config) ? 'read' : 'write'} onChange={changeMode}
      disabled={readOnly} options={[{ value: 'write', label: t('graphicDesignLesson.admin.intentWrite') },
        { value: 'read', label: t('graphicDesignLesson.admin.intentRead') }]} />
  </Form.Item>}</Form>;
};
export default ExerciseTypePicker;
